import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC } from 'react';
import SelectCustom from 'components/ui/SelectCustom/SelectCustom';
import { FilterModel } from 'ts/hotel/classes/FilterModel';
import { useTranslation } from 'react-i18next';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface FilterByKmProps {
  onFilterChange: (filter: FilterModel) => void;
  filter: FilterModel;
}

const FilterByKm: FC<FilterByKmProps> = (props) => {
  const { t } = useTranslation();

  const options = [
    { value: undefined, label: t('km') },
    { value: 1, label: `1 ${t('km')}` },
    { value: 2, label: `2 ${t('km')}` },
    { value: 3, label: `3 ${t('km')}` },
    { value: 5, label: `5 ${t('km')}` },
    { value: 8, label: `8 ${t('km')}` },
    { value: 13, label: `13 ${t('km')}` },
    { value: 20, label: `20 ${t('km')}` },
  ];

  return (
    <div className={'hotel-km' + (props.filter.location.km ? ' active' : '')}>
      <FontAwesomeIcon icon={faLocationDot} />
      <SelectCustom
        options={options}
        appendToBody={true}
        value={props.filter.location.km}
        onChange={(km) =>
          props.onFilterChange({ ...props.filter, location: { ...props.filter.location, km } })
        }
      />
    </div>
  );
};

export default withErrorBoundary(FilterByKm, 'FilterByKm');
